export default __webpack_public_path__ + "static/media/mobile.9952e04a.png";